<template>
  <loading padding="8" v-if="loading" />
  <div v-else>
    <tabs css="bg-transparent">
      <tab @input="activeTab = 0" :active="activeTab === 0">
        {{ capitalize($t("news.planned")) }}
      </tab>
      <tab @input="activeTab = 1" :active="activeTab === 1">
        {{ capitalize($t("news.published")) }}
      </tab>
      <tab @input="activeTab = 2" :active="activeTab === 2">
        {{ capitalize($t("news.unpublished")) }}
      </tab>
    </tabs>
    <div v-if="newsEntries.length > 0">
      <div class="p-2">
        <wd-filter
          :filters="filters"
          :input-array="activeTab === 0 ? plannedNewsEntries : newsEntries"
          @update="activeTab === 0 ? updatePlannedEntries($event) : updateEntries($event)"
        />
      </div>
      <div class="grid grid-cols-fit-250 gap-1" v-if="activeTab === 0">
        <news-entry
          v-for="entry in filteredPlannedNewsEntries"
          :key="entry.id"
          :entry="entry"
          :category="getCategory(entry.news_category_id)"
        />
      </div>
      <div class="grid grid-cols-fit-250 gap-1" v-if="activeTab === 1">
        <news-entry
          v-for="entry in publishedNewsEntries"
          :key="entry.id"
          :entry="entry"
          :category="getCategory(entry.news_category_id)"
        />
      </div>
      <div class="grid grid-cols-fit-250 gap-1" v-if="activeTab === 2">
        <news-entry
          v-for="entry in filteredUnpublishedNewsEntries"
          :key="entry.id"
          :entry="entry"
          :category="getCategory(entry.news_category_id)"
        />
      </div>

      <load-more-section
        show-count
        name="newsentryPlanned"
        :button-text="$t('general.show_more')"
        @input="getPlannedNewsEntries()"
        v-if="activeTab === 0"
      />
      <load-more-section
        show-count
        name="newsentryUnpublished"
        :button-text="$t('general.show_more')"
        @input="getUnpublishedNewsEntries()"
        v-else-if="activeTab === 2"
      />
      <load-more-section
        show-count
        name="newsentry"
        :button-text="$t('general.show_older_entries')"
        @input="getNewsEntries()"
        v-else
      />
    </div>
    <fab @input="openCreate">
      <icon name="Plus" />
    </fab>
  </div>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";

const NewsEntry = require("@/modules/news/components/NewsEntry.vue").default;
const Fab = require("@/modules/core/components/Fab.vue").default;
const LoadMoreSection = require("@/modules/core/components/LoadMoreSection.vue")
  .default;

const WdFilter = require("@/modules/core/components/WdFilter.vue").default;
const Tabs = require("@/modules/core/components/Tabs.vue").default;
const Tab = require("@/modules/core/components/Tab.vue").default;

export default {
  name: "NewsSite",
  mixins: [DateMixin],
  data() {
    return {
      newsEntries: null,
      unpublishedNewsEntries: null,
      plannedNewsEntries: null,
      newsCategories: [],
      filteredNewsEntries: [],
      filteredUnpublishedNewsEntries: [],
      filteredPlannedNewsEntries: [],
      filters: [],
      activeTab: 0,
    };
  },
  props: {},
  components: {
    NewsEntry,
    Fab,
    LoadMoreSection,
    WdFilter,
    Tabs,
    Tab,
  },
  methods: {
    getCategory(Id) {
      return this.$store.getters["newscategory/newsCategory"](Id);
    },
    openCreate() {
      this.goTo("/news-create/");
    },
    async getNewsEntries() {
      this.newsEntries = await this.getEntity("newsentry");
      this.filterableEntries = this.newsEntries;
    },
    async getUnpublishedNewsEntries() {
      this.unpublishedNewsEntries = await this.getEntity("newsentry", "Unpublished");
      this.filteredUnpublishedNewsEntries = this.unpublishedNewsEntries;
    },
    async getPlannedNewsEntries() {
      this.plannedNewsEntries = await this.getEntity("newsentry", "Planned");
      this.filteredPlannedNewsEntries = this.plannedNewsEntries;
    },
    updateEntries(In) {
      this.filteredNewsEntries = In;
    },
    updatePlannedEntries(In) {
      this.filteredPlannedNewsEntries = In;
    },
  },
  computed: {
    publishedNewsEntries() {
      return this.filteredNewsEntries.filter((e) => e.published);
    },
  },
  async created() {
    this.newsCategories = await this.$store.getters[
      "newscategory/api"
    ].GetAll();
    await this.getNewsEntries();
    await this.getUnpublishedNewsEntries();
    await this.getPlannedNewsEntries();
    this.filters.push(
      {
        name: this.$t("general.title"),
        key: "title",
        input: "text",
      },
      {
        name: this.$t("news.news_category"),
        key: "news_category_id",
        input: "select",
        type: "equal",
        options: this.newsCategories,
        optionId: "id",
        optionLabel: "title",
      },
      {
        name: this.$t("news.featured"),
        key: "featured",
        input: "check",
        type: "equal",
      }
    );

    this.loaded();
  },
};
</script>
